import {Component, Input} from '@angular/core';
import {IconComponent} from '../../icons/icon.component';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-profile-image',
  imports: [
    IconComponent,
    NgClass
  ],
  templateUrl: './profile-image.component.html',
  styleUrl: './profile-image.component.scss'
})
export class ProfileImageComponent {
  @Input() size: 'default' | 'header' | 'profile' | 'demo' = 'default';
  imageSrc = ''; // todo
}
